export default "__VITE_ASSET__BhJemSUW__"